
/*
 * ADJUST VAR FOR BREACKPOINTS
 */
function breakpoints() {

    viewport = $(window).width();

    if (viewport < sm) {
        // mobile
        navMinWidth     = '180px';
        navMaxWidth     = "200px";
        navTextTopMin   = '20px';
        navTextTopMax   = '25px';
        navTextRightMin = '15px';
        navTextRightMax = '25px';

        //} else if (viewport < md) {
        //mobile landscape

    } else if (viewport < lg) {
        // tablet
        navMinWidth     = '300px';
        navMaxWidth     = '350px';
        navTextTopMin   = '35px';
        navTextTopMax   = '50px';
        navTextRightMin = '35px';
        navTextRightMax = '40px';

    } else if (viewport < xl) {
        // laptop
        navMinWidth     = "300px";
        navMaxWidth     = '350px';
        navTextTopMin   = '30px';
        navTextTopMax   = '40px';
        navTextRightMin = '30px';
        navTextRightMax = '40px';

    } else if (viewport < gl) {
        // desktop
        navMinWidth     = '300px';
        navMaxWidth     = '400px';
        navTextTopMin   = '30px';
        navTextTopMax   = '50px';
        navTextRightMin = '30px';
        navTextRightMax = '40px';

    } else if (viewport >= gl) {
        // desktop larger
        navMinWidth     = '400px';
        navMaxWidth     = '500px';
        navTextTopMin   = '40px';
        navTextTopMax   = '60px';
        navTextRightMin = '40px';
        navTextRightMax = '50px';
    }
}
